export default {
  props: {
    callExtFuncOnEmit: Object
  },
  methods: {
    /*
     * @example for template
     * :call-ext-func-on-emit="{change: 'extFunctionName'}"
     * :call-ext-func-on-emit="{change: {funcName: 'showMoreDisclosureFields', params: ['p']}}"
     * */
    callExtFunc(name, a = null, b = null, c = null, d = null, e = null, f = null) {
      if (this.callExtFuncOnEmit && this.callExtFuncOnEmit[name] !== undefined) {
        const func = this.callExtFuncOnEmit[name];
        if (typeof func === "object") {
          if (func.params[2] !== undefined) {
            window[func.funcName](func.params[0], func.params[1], func.params[2]);
          } else if (func.params[1] !== undefined) {
            window[func.funcName](func.params[0], func.params[1]);
          } else {
            window[func.funcName](func.params[0]);
          }
        } else {
          window[func](a, b, c, d, e, f);
        }
      }
    }
  }
};
